import { Nexus } from '../fg-api';

export function getInstance() {
  return Nexus.instance;
}